module.exports = __webpack_public_path__ + "static/media/iconSearchHover.90d1e393.svg";